export { default } from './TextareaAutosize';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TextareaAutosize/index.js
// module id = 418
// module chunks = 22